import React, { useContext, useCallback } from 'react';
import { connect } from 'react-redux';

import { makeGetTask } from '../selectors/tasks';

import { extractId } from '../utils/helpers';

import TaskContainer from '../containers/task-container';

import { OverlayTaskContext } from 'context/OverlayTaskContext';

import Task from './task';
import Tooltip from './tooltip';

const TaskInner = ({ id, name, children, onOpen }) => {
    if (name) {
        return (
            <Tooltip type="popout" className="taks-popout" showDelay={300} tooltip={<Task id={id} showActions={false} onClick={onOpen} />}>
                <span className="mention" onClick={onOpen}>{ children }</span>
            </Tooltip>
        );
    }

    return children;
};

const TaskMention = ({ id }) => {
    const overlayTask = useContext(OverlayTaskContext);

    const handleOpen = useCallback(() => {
        overlayTask?.openTask(id);
    }, [overlayTask?.openTask, id]);

    return (
        <TaskContainer id={id}>
            <TaskInner onOpen={handleOpen}>{id}</TaskInner>
        </TaskContainer>
    );
}

const makeMapStateToProps = () => {
    const getTask = makeGetTask();

    return ({ tasks }, ownProps) => ({
        task: getTask(tasks.items, extractId(ownProps.id))
    });
}

export default connect(makeMapStateToProps)(TaskMention);
